import { render, staticRenderFns } from "./ManagerCommissionHistoryTabs.vue?vue&type=template&id=7b66fca0"
import script from "./ManagerCommissionHistoryTabs.vue?vue&type=script&lang=js"
export * from "./ManagerCommissionHistoryTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports